import './WeatherLoader.css';

interface WeatherLoaderProps {
  /** Optional status text rendered beneath the animation. */
  message?: string;
}

/**
 * WeatherLoader — a sun-behind-drifting-clouds loading animation.
 *
 * Adapted from Uiverse.io/zanina-yassine. Colors respond to the app's
 * light / dark / system theme via --wl-* tokens (see WeatherLoader.css, which
 * uses the same 3-way selector idiom as environmental-canvas.css). The scene
 * itself is purely decorative (aria-hidden); the wrapper is a role="status"
 * live region so assistive tech announces the message, not the blobs.
 *
 * Used by the app's full-screen blocking loaders — ConfigProvider (config
 * load) and AuthProvider (authentication).
 */
export const WeatherLoader = ({ message }: WeatherLoaderProps) => (
  <div className="weather-loader" role="status" aria-live="polite">
    <div className="wl-scene" aria-hidden="true">
      {/* Solid sun disc + a pulsing halo copy stacked on top of it */}
      <span className="wl-sun" />
      <span className="wl-sun wl-sunshine" />

      <div className="wl-cloud wl-back">
        <span className="wl-right-back" />
        <span className="wl-left-back" />
      </div>
      <div className="wl-cloud wl-front">
        <span className="wl-left-front" />
        <span className="wl-right-front" />
      </div>
    </div>
    {message && <p className="wl-message">{message}</p>}
  </div>
);
